module.exports = __webpack_public_path__ + "static/media/shapping.d07b95c1.jpg";